import { type PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

import { KanplaLogoNew } from "~/components/KanplaLogoNew";
import { useMultiClickAction } from "~/hooks/use-multi-click-action";
import { useKioskStore } from "~/routes/__app.kiosk/route";

export const LandingScreen = ({ children }: PropsWithChildren) => {
  const companyLogo = useKioskStore((state) => state.logoUrl);
  const navigate = useNavigate();

  const handleLogoClick = useMultiClickAction({
    clicksRequired: 3,
    timeoutMs: 1000,
    onAction: () => {
      navigate("admin");
    }
  });

  return (
    <div className="size-full">
      <div className="flex h-full flex-col justify-between bg-kiosk-landing-background p-16 pt-32 text-center">
        <div className="flex h-16 justify-center">
          <button type="button" onClick={handleLogoClick}>
            {companyLogo ? (
              <img alt="logo" src={companyLogo} className="h-40" />
            ) : (
              <KanplaLogoNew />
            )}
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};
